"use client";

import Image from "next/image";
import { useTranslations } from "next-intl";

import { Link } from "@/navigation";

const NAMESPACE = "new-sls-selective-laser-sintering";

const HERO_IMAGE =
	"/image/new-version/more/SLS/vapor-smoothing-for-sls-3d-printed-parts-cost-effective-grade.webp";

export default function SlsVaporSmoothing() {
	const t = useTranslations(NAMESPACE);

	return (
		<section className="bg-white py-8 sm:py-10 md:py-12 lg:py-16">
			<div className="container">
				<div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:gap-12 xl:gap-16">
					<div className="flex-1">
						<h2 className="mb-4 text-2xl font-bold leading-tight text-black sm:mb-6 sm:text-[30px] md:text-4xl">
							{t("vaporSmoothingTitle")}
						</h2>
						<div className="mb-6 space-y-4 text-sm leading-relaxed text-black md:text-base">
							<p>{t("vaporSmoothingDesc1")}</p>
							<p>{t("vaporSmoothingDesc2")}</p>
						</div>
						<Link
							href="/contact-us"
							className="inline-flex items-center justify-center rounded bg-themePrimary400 px-6 py-3 text-sm font-semibold text-white transition-all duration-300 hover:bg-opacity-80 hover:text-white md:px-8 md:py-3.5 md:text-base"
						>
							{t("vaporSmoothingContactUs")}
						</Link>
					</div>

					<div className="w-full lg:w-[45%] lg:shrink-0">
						<div className="relative aspect-[4/3.5] w-full overflow-hidden">
							<Image
								src={HERO_IMAGE}
								alt={t("vaporSmoothingImageAlt")}
								fill
								className="object-cover"
								sizes="(max-width: 1024px) 100vw, 45vw"
							/>
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
